// PointerSync.tsx — Re-runs the pointer raycast every frame so hover state follows
// a moving scene. R3F only raycasts on native pointer-move events; with the cursor
// held still, a planet that orbits under it (or a body the camera glides over) never
// re-fires onPointerOver/onPointerOut, so the selection caret would stick to whatever
// body was last touched. events.update() replays the last pointer position against the
// current scene each frame — a no-op until the pointer has moved once. Renders nothing.
import { useFrame, useThree } from '@react-three/fiber';

export function PointerSync() {
  const events = useThree((state) => state.events);

  useFrame(() => {
    events.update?.();
  });

  return null;
}
